import { generateQueryParams } from 'utils'
import CommonService from './common.service'
import { _object } from 'utils/interfaces'

class PageService extends CommonService {
  async getPages(params: _object) {
    return await this.get(`/pages?${generateQueryParams(params)}`)
  }

  async addPage(params: _object) {
    return await this.post('/pages', params)
  }

  async getPageDetails(id: string | undefined) {
    return await this.get(`/pages/${id}`)
  }

  async updatePage(id: string | undefined, params: _object) {
    return await this.put(`/pages/${id}`, params)
  }

  async deletePage(id: string | undefined) {
    return await this.delete(`/pages/${id}`)
  }
}

export const pageService = new PageService()
